// User service for handling user-related API endpoints
import { api } from './token_handler'


export default {

  // Get user ID
  async getUserData() {
    try {
      const response = await api.get('/users/user-data');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al obtener el ID del usuario' };
    }
  },

  // Get all users
  async getUsers(params = {}) {
    try {
      const response = await api.get('/users', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al obtener usuarios' };
    }
  },

  // Get user by ID
  async getUserById(userId) {
    try {
      const response = await api.get(`/users/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al obtener usuario' };
    }
  },

  // Create new user
  async createUser(userData) {
    try {
      const response = await api.post('/users', userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al crear usuario' };
    }
  },

  // Update user
  async updateUser(userId, userData) {
    try {
      const response = await api.put(`/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al actualizar usuario' };
    }
  },

  // Delete user
  async deleteUser(userId) {
    try {
      const response = await api.delete(`/users/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al eliminar usuario' };
    }
  },

  // Get user profile
  async getUserProfile() {
    try {
      const response = await api.get('/users/profile');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al obtener perfil de usuario' };
    }
  },

  // Update user profile
  async updateUserProfile(profileData) {
    try {
      const response = await api.put('/users/profile', profileData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al actualizar perfil de usuario' };
    }
  },

  // Change password
  async changePassword(passwordData) {
    try {
      const response = await api.post('/users/change-password', passwordData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al cambiar contraseña' };
    }
  },

  // Get user roles
  async getUserRoles(userId) {
    try {
      const response = await api.get(`/users/${userId}/roles`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al obtener roles de usuario' };
    }
  },

  // Assign role to user
  async assignRoleToUser(userId, roleId) {
    try {
      const response = await api.post(`/users/${userId}/roles`, { roleId });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al asignar rol al usuario' };
    }
  },

  // Remove role from user
  async removeRoleFromUser(userId, roleId) {
    try {
      const response = await api.delete(`/users/${userId}/roles/${roleId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al remover rol del usuario' };
    }
  },

  // Get consulting rooms
  async getConsultingRooms() {
    try {
      const response = await api.get('/consulting-rooms/consulting-rooms');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al obtener consultorios' };
    }
  },

  async getAllCommunications(offset = 0, limit = 1000, filters = null) {
    try {
      const filtersString = filters ? encodeURIComponent(JSON.stringify(filters)) : null;
      const response = await api.get('/consulting-rooms/all-communications', { params: { offset, limit, filters: filtersString } });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al obtener todas las comunicaciones' };
    }
  },

  async getMessagesMetrics(filters = null) {
    try {
      const filtersString = filters ? encodeURIComponent(JSON.stringify(filters)) : null;
      const response = await api.get('/consulting-rooms/messages-metrics', { params: { filters: filtersString } });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al obtener las métricas de los mensajes' };
    }
  },

  async getCallsMetrics(filters = null) {
    try {
      const filtersString = filters ? encodeURIComponent(JSON.stringify(filters)) : null;
      const response = await api.get('/consulting-rooms/calls-metrics', { params: { filters: filtersString } });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al obtener las métricas de las llamadas' };
    }
  },

  async fetchCommunicationRecord(id) {
    try {
      const response = await api.get(`/consulting-rooms/communication-record/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al obtener el registro de comunicación' };
    }
  },

  async updateCommunicationRecord(updateData) {
    try {
      const response = await api.put('/consulting-rooms/update-communication-record', updateData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error al actualizar el registro de comunicación' };
    }
  }

}; 